var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3332 1.8H11.6666L10.4916 0.531C10.1749 0.189 9.7499 0 9.30824 0H4.9999C4.08324 0 3.34157 0.81 3.34157 1.8L3.33324 12.6C3.33324 13.59 4.08324 14.4 4.9999 14.4H18.3332C19.2499 14.4 19.9999 13.59 19.9999 12.6V3.6C19.9999 2.61 19.2499 1.8 18.3332 1.8ZM0.833333 3.60003C0.375 3.60003 0 4.00503 0 4.50003V8.10003H0.00833333L0 16.2C0 17.19 0.75 18 1.66667 18H15.8333C16.2917 18 16.6667 17.595 16.6667 17.1C16.6667 16.605 16.2917 16.2 15.8333 16.2H2.5C2.04167 16.2 1.66667 15.795 1.66667 15.3V4.50003C1.66667 4.00503 1.29167 3.60003 0.833333 3.60003ZM9.25838 6.76799L6.33338 10.98C6.12505 11.277 6.32505 11.7 6.66671 11.691H16.6584C17 11.691 17.2 11.259 16.9834 10.962L14.9084 8.08199C14.7417 7.85699 14.425 7.84799 14.2584 8.07299L12.5084 10.35L9.92505 6.75899C9.75005 6.52499 9.42505 6.53399 9.25838 6.76799Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedia);
export default __webpack_public_path__ + "static/media/media.24d4aab871b32bb81cf0904546953667.svg";
export { ForwardRef as ReactComponent };